var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.86 13.32H1.14C1.063 13.32 1 13.383 1 13.46V14.86C1 14.937 1.063 15 1.14 15H14.86C14.937 15 15 14.937 15 14.86V13.46C15 13.383 14.937 13.32 14.86 13.32ZM3.47975 11.92H4.96725C5.04075 11.92 5.10725 11.8728 5.13 11.801L6.06975 8.896H9.90575L10.8368 11.801C10.8595 11.871 10.9243 11.92 10.9995 11.92H12.5588C12.578 11.92 12.5972 11.9165 12.6147 11.9113C12.6359 11.904 12.6555 11.8926 12.6723 11.8777C12.689 11.8628 12.7027 11.8448 12.7125 11.8246C12.7222 11.8045 12.7279 11.7825 12.7291 11.7602C12.7304 11.7378 12.7272 11.7154 12.7198 11.6942L9.078 1.1155C9.06619 1.0821 9.04443 1.05311 9.01564 1.03246C8.98685 1.01181 8.95243 1.00048 8.917 1H7.12675C7.05325 1 6.9885 1.0455 6.96575 1.1155L3.31875 11.6942C3.31175 11.7118 3.31 11.731 3.31 11.7502C3.30825 11.843 3.38525 11.92 3.47975 11.92ZM7.958 2.88825H8.02975L9.49625 7.50475H6.47575L7.958 2.88825Z",
    fill: "#767D92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.c8bc38b38923a3bd6fe3bd9d56a1c011.svg";
export { ForwardRef as ReactComponent };